import { render, staticRenderFns } from "./contentmenu.vue?vue&type=template&id=1ff2b5c8&"
import script from "./contentmenu.vue?vue&type=script&lang=js&"
export * from "./contentmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports